import { INPUT_GROUPS_MAX_ITEMS } from 'Constants/'
import debounce from 'lodash.debounce'
import {
  Select,
  SELECT_VARIANT_WITH_CHECKBOX,
  useAsyncSelect
} from 'mailup-web-components'
import { getGroupById, getGroups } from 'Pages/Task/recoil/actions/asyncSearch'
import { errorCallback } from 'Pages/Task/recoil/callbacks/callbacks'
import PropTypes from 'prop-types'
import { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback } from 'recoil'

const ExcludeGroups = ({ handleSelectChange, listOptions }) => {
  const intl = useIntl()

  const onError = useRecoilCallback(errorCallback, [])

  const getInitialItems = () => getGroups()

  const getItemsByTerm = (searchTerm) => getGroups(searchTerm)

  const hints = {
    loading: intl.formatMessage({ id: 'Load.MailupCommon.InputStatusLoading' }),
    moreResults: intl.formatMessage({
      id: 'Load.Filters.ActivityMessagesMoreResults'
    }),
    noResults: intl.formatMessage({ id: 'Load.Common.NoResultChosen' })
  }

  const {
    options,
    loading,
    hint,
    hintNoResults,
    onSearch,
    onChange,
    onExpandCollapse
  } = useAsyncSelect({
    initialValue: listOptions,
    getInitialItems,
    getItemsByTerm,
    getItemById: getGroupById,
    onError,
    hints,
    maxItems: INPUT_GROUPS_MAX_ITEMS
  })

  const handleChange = (value) => {
    handleSelectChange(value)
    onChange(value)
  }

  const { current: debouncedOnSearch } = useRef(debounce(onSearch, 350))

  const handleSearch = (s) => {
    debouncedOnSearch.cancel()
    debouncedOnSearch(s)
    return s
  }

  return (
    <Select
      multiple
      searchable
      variant={SELECT_VARIANT_WITH_CHECKBOX}
      value={listOptions}
      hint={hint}
      hintNoResults={hintNoResults}
      onChange={handleChange}
      loading={loading}
      options={options}
      onSearch={handleSearch}
      onExpandCollapse={onExpandCollapse}
      placeholder={intl.formatMessage({
        id: 'Load.SearchRecipients.ExcludeGroupsPlaceholder'
      })}
      data-mu-test='select-exclude-groups'
    />
  )
}

ExcludeGroups.propTypes = {
  handleSelectChange: PropTypes.func.isRequired,
  listOptions: PropTypes.array.isRequired
}

export default ExcludeGroups
